import React,{useEffect, useState} from 'react';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { Grid,Box,Typography,Button,Tooltip } from '@mui/material';
import KrGradeDetails from '../KrGradeDetails/KrGradeDetails';
import DeleteIcon from '@mui/icons-material/Delete';
import {IconButton} from '@mui/material';
import { useDeleteKr,useLikeKr,useDisLikeKr } from '../../Hooks';
import { useSelector,useDispatch } from 'react-redux';
import { setOkrDeleteStateR } from '../../OKRManageSlice/OKRManageSlice';
import EditIcon from '@mui/icons-material/Edit';
import TransferIcon from '@mui/icons-material/Transform';
import LikeIcon from '@mui/icons-material/Favorite';
import "../../../CompanyManagment/Copmonents/Like/Like.css";
// import { column, from } from 'stylis';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DyLinearProgress from '../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import CommentModal from '../../../TenantDash/LComponents/AllTenantDash/AnotherComponent ';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import CooperationRequest from '../../../CompanyTeams/LComponents/CooperationRequest/CooperationRequest';
import TransferKeyResult from '../TransferKeyResult/TransferKeyResult';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';

const OKRsCart = (props:any) => {
  const dispatch=useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const deleteOkrState=useSelector((state:any)=>state.okrManage.okrDeleteData);
  const{mutate:likeKr,data:likeData}=useLikeKr()
  const{mutate:disLikeKr,data:disLikeData}=useDisLikeKr()
  const[showKrDetails,setShowKrDetails]=useState<Boolean>(false);
  const[showKrRequest,setShowKrRequest]=useState<Boolean>(false);
  const[showTransfer,setShowTransfer]=useState<Boolean>(false);
  const userId=useSelector((state:any)=>state.loign.userInfo.userId);
  const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const [activeBtn, setActiveBtn] = useState<string>("none");
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [showToastMessage, setShowToastMessage] = useState<any>(null);

  const afterSuccessDelete=()=>{
    setTimeout(() => {
      dispatch(setOkrDeleteStateR(null))
    }, 3000);
  }
  const{mutate:callDeleteKr,data:deleteData,isSuccess}=useDeleteKr()
  let{item,setKrId,setIteam,setShowEditKr,setAddKrState,personPicture}=props;
  let{name,okrStateName,responsibleName,pointingSystemType,okR_KeyResultType,evaluationPercentage,okR_GradeDetails
        ,id,liked,likeCount,commentCount, periodId, definitionLevelId,responsibleId	}:any=item;

  const [likec, setLikeCount] = useState<number>(likeCount);

const initialShowDet=()=>{
  setShowKrDetails(true);
}

const initialRequestShowDet=()=>{
  setShowKrRequest(true);
}

const initialTransferShowDet=()=>{
  setShowTransfer(true);
}

const initialEditKr=()=>{
  setKrId(id);
  setIteam(item);
  setShowEditKr(true);
}
const handleClickOpen = () => {
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
};
const initialDeleteKr=()=>{
  let deleteBody={
    deletedId:id,
    userId:userId,
    tenantId:tenantId
}
callDeleteKr(deleteBody)
handleClose();
}

useEffect(() => {
  setTimeout(() => {
    dispatch(setOkrDeleteStateR(null))
}, 3000);

}, [deleteOkrState])


const initialLikeKr=()=>{
  let deleteBody={
  keyResultId:id,
  tenantId:tenantId
  }
  likeKr(deleteBody)
  }

  const initialDisLikeKr=()=>{
    let deleteBody={
    keyResultId:id,
    tenantId:tenantId
    }
    disLikeKr(deleteBody)
    }

    useEffect(() => {
      if (item) {
        setLikeCount(likeCount)
        if (liked) {
          setActiveBtn("like");
        }
      }
    }, likeCount)

    const handleReactionClick = (reaction: string): void => {
      if (activeBtn === "none") {
         if (reaction === "like") {
          setLikeCount(likec + 1);
          setActiveBtn("like");
          initialLikeKr();
        }
      } else if (activeBtn === reaction) {
        if (reaction === "like") {
          setLikeCount(likec - 1);
          initialDisLikeKr();
        }
        setActiveBtn("none");
      } 
      else if (activeBtn !== reaction) {
        if (reaction === "like") {
          setActiveBtn("like");
        }
      }
    };    
    const [open, setOpen] = React.useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    < >
             <Grid container boxShadow={4} borderRadius={4} p={2} >
            <Grid item xs={12}  >
           <Grid container alignItems={'center'} >
           <Grid item xs={12} sm={12}  >
            <Box    display={'flex'} 
        width={'100%'}
        alignItems={'start'}
        minHeight={'80px'} 
        justifyContent={'space-between'}
        >
        <Box display={'flex'}>        
            {
                  name.length > 65 ? <Tooltip  sx={{ fontSize: '1.5rem !important' }} title={name}>
              <Typography mt={1} textAlign={'left'}   variant='body1'sx={{ fontSize: '13px !important', fontWeight:'600',color: 'black',cursor:'pointer'}}   >{name.slice(0,65)}</Typography>
            </Tooltip> : <Typography mt={1} textAlign={'left'} sx={{ fontSize: '13px !important',fontWeight:'600', color: 'black',cursor:'pointer'}}    >
              {
                 name
              }
            </Typography>
       }
          </Box>
          <Box display={'flex'}  justifyContent={'end'}>
      <Tooltip  title="ویرایش">
      <IconButton onClick={initialEditKr} >
      <EditIcon color='primary'   />
      </IconButton>
      </Tooltip>
      <Tooltip  title="حذف">
        <IconButton  onClick={handleClickOpen}>
        <DeleteIcon color='error'   />
       </IconButton>
       </Tooltip>
       <Tooltip  title="انتقال هدف نتیجه کلیدی به هدف دیگر ">
      <IconButton onClick={initialTransferShowDet} >
      <TransferIcon color='primary'   />
      </IconButton>
      </Tooltip>
       <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
          {"آیا از حذف نتیجه کلیدی اطمینان دارید؟"}
        </DialogTitle>
        <DialogActions >
          <Button autoFocus onClick={handleClose} >
            <Typography  color={'red'}> انصراف</Typography> 
          </Button>
          <Button onClick={initialDeleteKr} autoFocus>
            <Typography  color={'#00387C'} > تایید</Typography> 
          </Button>
        </DialogActions>
      </Dialog>      
      </Box>
      </Box>
            {/* </Grid> */}
            </Grid>

           </Grid>
            </Grid>
            
            <Grid container  >
            <Grid item xs={12}  sm={12} >
            <Box display={'flex'} justifyContent={'start'}  >
            {/* <PersonIcon width={'15px'}  height={'15px'} />  */}

             <Typography variant='body2' fontWeight={700} >مسئول : </Typography>
                             {/* <Box display={'flex'} justifyContent={'start'}  >
                             <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture?.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
                  personPicture?.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
                  ?
                  personPicture?.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
                  :''
                } width={'20px'} height={'20px'} style={{borderRadius:'50%'}} />
             <Typography variant='body2' fontWeight={500} px={0.5}  >
                 {
                    responsibleName
                 }
                </Typography>
                            </Box> */}
                            <Box display={'flex'} justifyContent={'start'} alignItems={'center'}>
  <Box
    width="20px"
    height="20px"
    display="flex"
    alignItems="center"
    justifyContent="center"
    overflow="hidden"
    borderRadius="50%"
  >
    <img
      src={
        personPicture !== null &&
        personPicture !== undefined &&
        personPicture?.filter((x: any) => x.personId === responsibleId)[0] !==
          null &&
        personPicture?.filter((x: any) => x.personId === responsibleId)[0] !==
          undefined
          ? personPicture?.filter((x: any) => x.personId === responsibleId)[0]
              .pictureBase64String
          : ''
      }
      alt="Responsible"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain", // نمایش کامل تصویر با تناسب
      }}
    />
  </Box>
  <Typography variant="body2" fontWeight={500} px={0.5}>
    {responsibleName}
  </Typography>
</Box>

            </Box>
            </Grid>
            <Grid item xs={12}  sm={7} >
            <Box display={'flex'} justifyContent={'start'}  >
             <Typography variant='body2' fontWeight={700} >سیستم امتیاز دهی :</Typography>
             <Typography variant='body2' px={0.5} fontWeight={500}  >
                 {
                    pointingSystemType
                 }
                </Typography>
            </Box>
            </Grid>

            <Grid xs={12}  >
        <Box width={'100%'} display={'flex'} flexDirection={'row'} >
        <Box width={'100%'} display={'flex'} justifyContent={'start'}>
             <Typography variant='body2' fontWeight={700} >نوع نتیجه : </Typography>
             <Typography variant='body2' fontWeight={500} px={0.5}  >
                 {
                    okR_KeyResultType
                 }
                </Typography>
            </Box>
        {/* <Box>
        <div className="btnn-container">
            <button 
          className={`btnn ${activeBtn === "like" ? "like-active " : ""}`}
          onClick={() => handleReactionClick("like")}
        >
          <LikeIcon />{likec}
        </button>
        </div>
        </Box> */}
        <Grid container xs={12} justifyContent="flex-end">
  <Box display={'flex'} alignItems={'center'}>
    <Box mr={2}>
      <CommentModal id={id} name={name} commentCount={commentCount}/>
    </Box>
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <div className="btnn-container">
        <button 
          className={`btnn ${activeBtn === "like" ? "like-active" : ""}`}
          onClick={() => handleReactionClick("like")}
        >
          <LikeIcon />{likec}
        </button>
      </div>
    </Box>
  </Box>
</Grid>
        </Box>
            </Grid>
            </Grid>
           
            <Grid item xs={12} >
             <Box width={'100%'}   >
                <DyLinearProgress value={evaluationPercentage}  />
             </Box>
             
           </Grid>

         <Grid xs={12} sm={12} display="flex" alignItems="center" justifyContent="space-between">
  <Box display="flex" alignItems="center" justifyContent="center"
       bgcolor={okrStateName === "فعال" ? '#D5f7D4' : '#bfd3f5'} width="90px" height="28px" borderRadius={3} marginRight={1}>
    <Typography color={okrStateName === 'فعال' ? 'green' : 'blue'} fontSize="0.8rem">
      {okrStateName === "فعال" ? 'فعال' : 'پیش نویس'}
    </Typography>
  </Box>
  <DyButton caption="همسویی افقی: درخواست/ پیشنهاد همکاری" onClick={initialRequestShowDet}
            disabled={false} variant="contained" type="button" bgColor="#00387C"
            sx={{ width: '150px', fontSize: '0.75rem', padding: '4px 8px', marginLeft: '16px' }} />
</Grid>

             <Box marginTop={3}> </Box>
             {
                showKrDetails && <ModalLyt 
                showModal={showKrDetails} 
                setShowModal={setShowKrDetails}
                title={'نمایش اطلاعات '}
                >
                  <KrGradeDetails gradeDetails={okR_GradeDetails}/>     
                </ModalLyt>
             }
              <Box marginTop={3}> </Box>
             {
                showKrRequest && <ModalLyt 
                showModal={showKrRequest} 
                setShowModal={setShowKrRequest}
                width={isMobile ? '350px' : '1200px'} 
                title={'ثبت درخواست/ پیشنهاد همکاری'}
                 >
                  <CooperationRequest krId={id} teamId={definitionLevelId	} periodId={periodId} /> 
                </ModalLyt>
             }
               <Box marginTop={3}> </Box>
             {
                showTransfer && 
                <ModalLyt 
                  showModal={showTransfer} 
                  width={'500px'}
                  setShowModal={setShowTransfer}
                  title={'انتقال به هدف دیگر'}
                  >
                  <TransferKeyResult 
                    krId={id} 
                    teamId={definitionLevelId} 
                    periodId={periodId} 
                    setShowToastMessage={setShowToastMessage}
                    onClose={setShowTransfer}
                    /> 
                </ModalLyt>
             }
             {showLtoastMessage && (
                <DYToastMessage
                  isSuccess={true}
                  message={'عملیات با موفقیت انجام شد'}
                  setShow={setShowLtoastMessage}
                  show={showLtoastMessage}
                />
              )}

            {showToastMessage && (
                <DYToastMessage
                  isSuccess={true}
                  message={'عملیات با موفقیت انجام شد'}
                  setShow={setShowToastMessage}
                  show={showToastMessage}
                />
              )}
             </Grid>
        </>
  )
}

export default OKRsCart